module.exports = __webpack_public_path__ + "img/7.8d5ad553.png";